import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News/NewsList.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/News/NewsDetail.vue')
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('@/views/Shop/ShopList.vue')
  },
  {
    path: '/shop/category/:id',
    name: 'CategoryProducts',
    component: () => import('@/components/Shop/SearchResult.vue'),
    props: true
  },
  {
    path: '/shop/clothing/:id',
    name: 'ClothingDetail',
    component: () => import('@/views/Shop/ClothingDetail.vue')
  },
  {
    path: '/shop/fabric/:id',
    name: 'FabricDetail',
    component: () => import('@/views/Shop/FabricDetail.vue')
  },
  {
    path: '/shop/accessory/:id',
    name: 'AccessoryDetail',
    component: () => import('@/views/Shop/AccessoryDetail.vue')
  },
  {
    path: '/shop/equipment/:id',
    name: 'EquipmentDetail',
    component: () => import('@/views/Shop/EquipmentDetail.vue')
  },
  {
    path: '/supply-demand',
    name: 'SupplyDemand',
    component: () => import('@/views/SupplyDemand/SupplyDemandLayout.vue'),
    children: [
      {
        path: ':id',
        name: 'SupplyDemandDetail',
        component: () => import('@/views/SupplyDemand/SupplyDemandDetail.vue')
      },
      {
        path: 'rental/:id',
        name: 'RentalDetail',
        component: () => import('@/views/SupplyDemand/RentalDetail.vue')
      }
    ]
  },
  {
    path: '/finance',
    name: 'Finance',
    component: () => import('@/views/Finance/FinanceList.vue')
  },
  {
    path: '/finance/:id',
    name: 'FinanceDetail',
    component: () => import('@/views/Finance/FinanceDetail.vue')
  },
  {
    path: '/value-added',
    name: 'ValueAdded',
    redirect: '/value-added/consulting',
    children: [
      {
        path: 'consulting',
        name: 'ValueAddedConsulting',
        component: () => import('@/views/ValueAdded/ConsultingList.vue')
      },
      
      {
        path: 'job-apply',
        name: 'ValueAddedJobApply',
        component: () => import('@/views/ValueAdded/JobApplyList.vue')
      }
    ],
    component: () => import('@/views/ValueAdded/ValueAddedLayout.vue')
  },
  {
    path: '/about',
    name: 'AboutView',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/shop/store/:id',
    name: 'StoreDetail',
    component: () => import('@/views/Shop/StoreDetail.vue')
  },
  {
    path: '/shop/order/:id',
    name: 'OrderDetail',
    component: () => import('@/views/SupplyDemand/OrderDetail.vue')
  },
  {
    path: '/logistics',
    name: 'Logistics',
    component: () => import('@/views/Logistics/LogisticsList.vue')
  },
  {
    path: '/logistics/:id',
    name: 'LogisticsDetail',
    component: () => import('@/views/Logistics/LogisticsDetail.vue')
  },
  {
    path: '/live',
    name: 'LiveHome',
    component: () => import('@/views/Live/LiveHome.vue')
  },
  {
    path: '/live/info',
    name: 'LiveInfo',
    component: () => import('@/views/Live/LiveInfoList.vue')
  },
  {
    path: '/live/info/detail/:id',
    name: 'LiveInfoDetail',
    component: () => import('@/views/Live/LiveInfoDetail.vue')
  },
  {
    path: '/live/activity',
    name: 'LiveActivity',
    component: () => import('@/views/Live/LiveActivityList.vue')
  },
  {
    path: '/live/activity/detail/:id',
    name: 'LiveActivityDetail',
    component: () => import('@/views/Live/LiveActivityDetail.vue')
  },
  {
    path: '/live/training',
    name: 'LiveTraining',
    component: () => import('@/views/Live/LiveTrainingList.vue')
  },
  {
    path: '/live/training/detail/:id',
    name: 'LiveTrainingDetail',
    component: () => import('@/views/Live/LiveTrainingDetail.vue')
  },
//   {
//     path: '/events',
//     name: 'Events',
//     component: () => import('@/views/Events/EventsList.vue')
//   },
//   {
//     path: '/events/:id',
//     name: 'EventsDetail',
//     component: () => import('@/views/Events/EventsDetail.vue')
//   },
  {
    path: '/value-added',
    name: 'ValueAdded',
    redirect: '/value-added/consulting',
    children: [
      {
        path: 'consulting',
        name: 'ValueAddedConsulting',
        component: () => import('@/views/ValueAdded/ConsultingList.vue')
      },
      {
        path: 'job-apply',
        name: 'ValueAddedJobApply',
        component: () => import('@/views/ValueAdded/JobApplyList.vue')
      }
    ],
    component: () => import('@/views/ValueAdded/ValueAddedLayout.vue')
  },
  {
    path: '/about',
    name: 'AboutView',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/shop/store/:id',
    name: 'StoreDetail',
    component: () => import('@/views/Shop/StoreDetail.vue')
  },
  {
    path: '/shop/order/:id',
    name: 'OrderDetail',
    component: () => import('@/views/SupplyDemand/OrderDetail.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 检查路由是否存在
  const matchedRoute = router.resolve(to.path).matched
  if (matchedRoute.length === 0) {
    next('/404')
    return
  }
  next()
})

// 添加404路由
router.addRoute({
  path: '/404',
  name: '404',
  component: () => import('@/views/NotFound.vue')
})

// 捕获所有未匹配的路由
router.addRoute({
  path: '/:pathMatch(.*)*',
  redirect: '/404'
})

// 错误处理
router.onError((error) => {
  console.error('路由错误:', error)
  router.push('/')
})

export default router